var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLogo = function SvgLogo(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 462.7 129.47",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-7);}.cls-8{fill:url(#linear-gradient-8);}.cls-9{fill:url(#linear-gradient-9);}.cls-10{fill:url(#linear-gradient-10);}.cls-11{fill:url(#linear-gradient-11);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 102.17,
    y1: 63.99,
    x2: 641.69,
    y2: 52.55,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 130.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#05707e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#2b9297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4dbbba"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 102.18,
    y1: 64.78,
    x2: 641.71,
    y2: 53.33,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 102.19,
    y1: 65.29,
    x2: 641.72,
    y2: 53.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 102.21,
    y1: 66.05,
    x2: 641.74,
    y2: 54.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 102.23,
    y1: 66.79,
    x2: 641.75,
    y2: 55.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 102.25,
    y1: 67.83,
    x2: 641.77,
    y2: 56.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 102.31,
    y1: 70.8,
    x2: 641.84,
    y2: 59.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 73.08,
    y1: 0.68,
    x2: 12.14,
    y2: 103.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 3.65,
    y1: 124.93,
    x2: 90.51,
    y2: 93.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 73.03,
    y1: 82.64,
    x2: 92.32,
    y2: 82.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 82.44,
    y1: 71.92,
    x2: 82.89,
    y2: 1.6,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M180.4,90.42h29.09V99H165.36l29.76-52H170.23V38.4h39.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.29,38.4V99h-9.14V38.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M253,38.4v52h17.83V99h-27V38.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M288.67,38.4v52h17.82V99h-27V38.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M324.29,38.4V99h-9.14V38.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M400.55,100.12h-11.5l-4.76-4.87a30.6,30.6,0,0,1-16.88,4.87A31.62,31.62,0,0,1,346,92a29.28,29.28,0,0,1-10.17-23,30.21,30.21,0,0,1,9.62-22.85A31.66,31.66,0,0,1,388.21,45q11,9.34,11,24.38,0,11.78-8.67,20.92ZM375.39,75l8.79,8.76a20.77,20.77,0,0,0,5.81-15,22.44,22.44,0,0,0-6.48-16.29,21.63,21.63,0,0,0-16.09-6.6,21.17,21.17,0,0,0-16,6.6q-6.32,6.55-6.32,16.6,0,9.83,6.52,16.06a21.89,21.89,0,0,0,15.5,6.44,21.37,21.37,0,0,0,10.72-2.71L363.59,75.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M446.29,84.3H420.37L413.62,99h-9.85l30-64.42L462.7,99h-10Zm-3.73-8.6-9-20.61L424.14,75.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "73.03 61.9 22.93 86.55 73.03 110.31 73.03 129.47 0.04 94.86 0 76 50.79 51.03 0.04 26.97 0.04 7.81 73.03 42.42 73.03 61.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "0.04 7.81 19.33 0 92.32 34.6 73.03 42.42 0.04 7.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "73.03 61.9 92.32 54.08 92.32 34.6 73.03 42.42 73.03 61.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "73.03 110.31 73.03 72.01 92.32 63.14 92.32 121.65 73.03 129.47 73.03 110.31"
  })))))));
};
export default SvgLogo;